import i18n from "@/plugins/i18n";
import {
  ResourceTypesEnum,
  ActionTypesEnum
} from "@/modules/logs/audit-log/enums.js";

function parseResource(type) {
  switch (type) {
    case ResourceTypesEnum.APPLICATION_RULES:
      return i18n.t("layouts.app.applicationRules");
    case ResourceTypesEnum.DEVICES:
      return i18n.t("layouts.app.devices");
    case ResourceTypesEnum.ENVIRONMENTS:
      return i18n.t("layouts.app.environments");
    case ResourceTypesEnum.USERS:
      return i18n.t("layouts.app.users");
    case ResourceTypesEnum.VPN_CERTIFICATE:
      return i18n.t("modules.dataPath.vpn.vpnCertificate");
    case ResourceTypesEnum.VPN_PROFILES:
      return i18n.t("modules.dataPath.vpn.vpnProfiles");
    case ResourceTypesEnum.VERSIONS_MANAGEMENT:
      return i18n.t("layouts.app.versionManagement");
    case ResourceTypesEnum.DEVICES_IMPORT:
      return i18n.t("modules.devices.devicesImport");
    case ResourceTypesEnum.DEVICE_CERTIFICATE:
      return i18n.t("modules.devices.deviceCertificate");
    default:
      return "";
  }
}

function parseAction(type) {
  switch (type) {
    case ActionTypesEnum.CREATE:
      return i18n.t("modules.logs.auditLog.create");
    case ActionTypesEnum.UPDATE:
      return i18n.t("modules.logs.auditLog.update");
    case ActionTypesEnum.DELETE:
      return i18n.t("modules.logs.auditLog.delete");
    case ActionTypesEnum.ENABLE:
      return i18n.t("modules.logs.auditLog.enable");
    case ActionTypesEnum.DISABLE:
      return i18n.t("modules.logs.auditLog.disable");
    default:
      return "";
  }
}

function parseColor(type) {
  switch (type) {
    case i18n.t("modules.logs.auditLog.create"):
      return "audit_log__action__create";
    case i18n.t("modules.logs.auditLog.update"):
      return "audit_log__action__update";
    case i18n.t("modules.logs.auditLog.enable"):
      return "audit_log__action__enable";
    case i18n.t("modules.logs.auditLog.disable"):
      return "audit_log__action__disable";
    case i18n.t("modules.logs.auditLog.delete"):
      return "audit_log__action__delete";
    default:
      return "";
  }
}
const csvHeaders = {
  username: i18n.t("modules.logs.auditLog.username"),
  resource_name: i18n.t("modules.logs.auditLog.resource"),
  entity_name: i18n.t("modules.logs.auditLog.entity"),
  action_name: i18n.t("modules.logs.auditLog.action"),
  detail: i18n.t("modules.logs.auditLog.detail"),
  time: i18n.t("modules.logs.auditLog.time")
};

export default {
  parseResource,
  parseAction,
  parseColor,
  csvHeaders
};
